import * as THREE from 'three';

const moveCollectComponent = {
  schema: {},
  init: function () {
    this.rayOrigin = new THREE.Vector2(0, 0);
    this.raycaster = new THREE.Raycaster();
    this.ground = document.getElementById('ground');

    this.camera = document.getElementById('camera');
    this.threeCamera = this.camera.getObject3D('camera');
    this.cursorLocation = new THREE.Vector3(0, 0, 0);
    this.smoothedCursorLocation = new THREE.Vector3(0, 0, 0);
  },

  tick: function () {
    // Get camera position
    const cameraPos = this.camera.getAttribute('position');

    // Make collector follow camera's X position
    // Keep it centered in front of the camera at a fixed offset
    this.el.object3D.position.x = cameraPos.x;
    this.el.object3D.position.y = 0; // Fixed Y position
    this.el.object3D.position.z = -3; // Fixed Z position (in front of camera)

    // Optional: Add smooth rotation to match camera
    // this.el.object3D.rotation.y = this.threeCamera.rotation.y;
  },
};

export { moveCollectComponent };
